import { createAction } from '@ngrx/store';
import {
  zefActionPayload,
  zefActionFailPayload,
  zefActionSuccessPayload
} from '@zerops/zef/core';

export const resendVerificationEmail = createAction(
  '[@zerops/zerops/feature/email-verification-notification] resend-verification-email',
  zefActionPayload<{ id: string }>()
);

export const resendVerificationEmailFail = createAction(
  '[@zerops/zerops/feature/email-verification-notification] resend-verification-email/fail',
  zefActionFailPayload
);

export const resendVerificationEmailSuccess = createAction(
  '[@zerops/zerops/feature/email-verification-notification] resend-verification-email/success',
  zefActionSuccessPayload<{ success: boolean }>()
);

/**
 * Dispatched instead of the fail action when the API rejects the resend because the
 * e-mail is already verified. Carries `originalAction` so the shared progress reducer
 * clears the resend progress, while no `zefError` is emitted — this is not a user-facing
 * error, just a stale local `emailVerified` flag that needs to be corrected.
 */
export const resendVerificationEmailAlreadyVerified = createAction(
  '[@zerops/zerops/feature/email-verification-notification] resend-verification-email/already-verified',
  zefActionSuccessPayload<{ id: string }>()
);
